import { useTheme } from 'styled-components'

import { IconBase, IconProps } from './Base'
import { useIsMobile } from 'utils/useIsMobile'

export const IconError = (props: IconProps) => {
  const theme = useTheme()

  const isMobile = useIsMobile()

  return (
    <IconBase
      width={props.width || isMobile ? 64 : 150}
      height={props.height || isMobile ? 64 : 150}
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M2.20164 18.4695L10.1643 4.00506C10.9021 2.66498 13.0979 2.66498 13.8357 4.00506L21.7984 18.4695C22.4443 19.6428 21.4598 21 19.9627 21H4.0373C2.54022 21 1.55571 19.6428 2.20164 18.4695Z"
        stroke={theme.colors.text.primary}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 9V13"
        stroke={theme.colors.text.primary}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 17.0195V17"
        stroke={theme.colors.text.primary}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </IconBase>
  )
}
